module.exports = __webpack_public_path__ + "static/media/management_slider_phone3副本.d4d56717.png";